import { createStateContainer } from "@xoev/state-container";
import editorStateReducer from "./editorStateReducer";
import { EMPTY_EDITOR_STATE } from "./helpers";

const createEmptyStateContainer = () => {
	return createStateContainer(editorStateReducer, EMPTY_EDITOR_STATE);
};

export default createEmptyStateContainer;
